import React from 'react';
import AddIcon from '@mui/icons-material/Add';

import { observer } from 'mobx-react';
import { ChannelSort } from 'stream-chat';
import {
  Chat,
  ChannelList,
  Channel,
  MessageInput,
  MessageList,
  Thread,
  Window,
  LoadingIndicator,
} from 'stream-chat-react';
import { EmojiPicker } from 'stream-chat-react/emojis';
import 'stream-chat-react/dist/css/v2/index.css';

import './LbChat.scss';
import { chatStore } from '../../../../shared/stores/chatStore';
import { RefreshButton } from '../RefreshButton/RefreshButton';
import { CustomChannelHeader } from './CustomChannelHeader/CustomChannelHeader';

const LbChat = observer(() => {
  const { user, chatClient, activeChannelId } = chatStore;

  if (!chatClient || !user) {
    return <LoadingIndicator />;
  }

  const filters = { type: 'messaging', members: { $in: [user.id] } };
  const sort: ChannelSort = { last_message_at: -1 };

  return (
    <div className="str-chat_content_box">
      <Chat client={chatClient} theme="messaging str-chat__theme-lb">
        <div className="channel-container">
          <ChannelList
            filters={filters}
            sort={sort}
            customActiveChannel={activeChannelId}
          />
          <div className="refresh-button-container">
            <RefreshButton className="refresh-button" />
          </div>
        </div>
        <Channel
          EmojiPicker={EmojiPicker}
          AttachmentSelectorInitiationButtonContents={AddIcon}
        >
          <Window>
            <CustomChannelHeader />
            <MessageList />
            <MessageInput additionalTextareaProps={{ placeholder: 'Your message' }} />
          </Window>
          <Thread />
        </Channel>
      </Chat>
    </div>
  );
});

export { LbChat };
